import { useId, useState } from "react";
import { searchControls } from "../api/controls.api.js";
import { linkControlEntity } from "../services/controlLinks";
import ControlCreateModal from "./controls/ControlCreateModal";
import Button from "../ui/Button";
import Input from "../ui/Input";
import ModalA11yWrapper from "../ui/ModalA11yWrapper";

export default function LinkControlModal({ riskId, onClose, onLinked }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const titleId = useId();

  async function handleSearch() {
    try {
      setLoading(true);
      setError(null);
      const res = await searchControls(query || "");
      const data = res?.data;
      const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
      setResults(items);
    } catch (err) {
      setError(err.message || "Search failed");
    } finally {
      setLoading(false);
    }
  }

  async function handleLink(controlId) {
    try {
      setError(null);
      await linkControlEntity(controlId, "risks", riskId);
      onLinked();
    } catch (err) {
      setError(err.message || "Failed to link control");
    }
  }

  if (createOpen) {
    return (
      <ControlCreateModal
        open
        defaultRiskId={riskId}
        onClose={() => setCreateOpen(false)}
        onCreated={() => {
          onLinked && onLinked();
        }}
      />
    );
  }

  return (
    <ModalA11yWrapper open onClose={onClose} labelledBy={titleId}>
      <div className="modal">
        <h3 id={titleId}>Link Control</h3>

        <div className="modal-row">
          <Input
            label="Search controls"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search controls"
            style={{ flex: 1 }}
          />
          <Button
            onClick={handleSearch}
            disabled={loading}
            variant="secondary"
            style={{
              padding: "6px 12px",
              borderRadius: 999,
              border: "1px solid #d1d5db",
              background: "white",
              cursor: "pointer",
            }}
          >
            {loading ? "Searching..." : "Search"}
          </Button>
        </div>

        {error && (
          <div role="alert" style={{ color: "red" }}>
            {error}
          </div>
        )}

        <ul className="modal-list">
          {results.map((c) => (
            <li key={c.id} className="modal-list-item">
              <span>{c.name}</span>
              <Button onClick={() => handleLink(c.id)} variant="secondary">
                Link
              </Button>
            </li>
          ))}
          {results.length === 0 && !loading && (
            <li style={{ fontStyle: "italic" }}>No results yet.</li>
          )}
        </ul>

        <div className="modal-actions">
          <Button
            onClick={onClose}
            variant="secondary"
            style={{
              padding: "6px 12px",
              borderRadius: 999,
              border: "1px solid #d1d5db",
              background: "white",
              cursor: "pointer",
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setCreateOpen(true);
            }}
            variant="secondary"
            style={{
              padding: "6px 12px",
              borderRadius: 999,
              border: "1px solid #d1d5db",
              background: "white",
              cursor: "pointer",
            }}
          >
            Create Control
          </Button>
        </div>
      </div>
    </ModalA11yWrapper>
  );
}
